<div>
    <app-nav></app-nav>
    <div class="container mt-2">
        <router-outlet></router-outlet>
    </div>
    <footer>
        <app-footer></app-footer>
    </footer>
</div>
